import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useItemList = ({ wardrobeID, search, page }) => {
  const filter = {
    // filter: { wardrobeIDFilter: wardrobeID },
    filter: { wardrobeIDFilter: wardrobeID, searchTerm: search },
    paging: { pageIndex: page },
  };

  return useQuery({
    queryKey: ["itemListState", filter],
    queryFn: async () =>
      callApi({
        path: "wardrobeitems",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
    placeholderData: keepPreviousData,
    staleTime: 5000,
  });
};
